'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _desc, _value, _class2, _class3, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mobx = require('mobx');

var _mobxReact = require('mobx-react');

var _classAutobindDecorator = require('class-autobind-decorator');

var _classAutobindDecorator2 = _interopRequireDefault(_classAutobindDecorator);

var _Row = require('react-bootstrap/lib/Row');

var _Row2 = _interopRequireDefault(_Row);

var _CaseActivity = require('./CaseActivity');

var _CaseActivity2 = _interopRequireDefault(_CaseActivity);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var CaseTrackingUpdateRequest = (0, _classAutobindDecorator2.default)(_class = (0, _mobxReact.observer)(_class = (_class2 = (_temp = _class3 = function (_Component) {
  _inherits(CaseTrackingUpdateRequest, _Component);

  function CaseTrackingUpdateRequest() {
    _classCallCheck(this, CaseTrackingUpdateRequest);

    return _possibleConstructorReturn(this, (CaseTrackingUpdateRequest.__proto__ || Object.getPrototypeOf(CaseTrackingUpdateRequest)).apply(this, arguments));
  }

  _createClass(CaseTrackingUpdateRequest, [{
    key: 'render',
    value: function render() {
      var tracking_update_task = this.props.activity.tracking_update_task,
          recipient_name = tracking_update_task.recipient_name,
          recipient_email = tracking_update_task.recipient_email,
          text = 'A case update request was sent to ' + recipient_name + '.',
          activityBody = _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'h3',
          null,
          'Case Update Request'
        ),
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(
            'span',
            { className: 'status' },
            'To:'
          ),
          ' ',
          recipient_email
        ),
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(
            'span',
            { className: 'status' },
            'Status:'
          ),
          ' ',
          this.trackingUpdateTaskStatus
        ),
        _react2.default.createElement(
          _Row2.default,
          { className: 'bloc' },
          text
        )
      );


      return _react2.default.createElement(_CaseActivity2.default, _extends({
        activity_body: activityBody,
        dot: 'icon',
        icon: 'envelope',
        truncatedBody: text
      }, this.props));
    }
  }, {
    key: '__reactstandin__regenerateByEval',
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }, {
    key: 'trackingUpdateTaskStatus',
    get: function get() {
      var tracking_update_task = this.props.activity.tracking_update_task,
          completed_at = tracking_update_task.completed_at,
          reminded_at = tracking_update_task.reminded_at;


      if (completed_at) {
        return 'Responded';
      }
      return reminded_at ? 'Reminder sent' : 'Request sent';
    }
  }]);

  return CaseTrackingUpdateRequest;
}(_react.Component), _class3.propTypes = {
  activity: _propTypes2.default.shape({
    id: _propTypes2.default.string.isRequired,
    tracking_update_task: _propTypes2.default.object,
    type: _propTypes2.default.string.isRequired
  }).isRequired
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'trackingUpdateTaskStatus', [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, 'trackingUpdateTaskStatus'), _class2.prototype)), _class2)) || _class) || _class;

var _default = CaseTrackingUpdateRequest;
exports.default = _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(CaseTrackingUpdateRequest, 'CaseTrackingUpdateRequest', '/app/src/components/common-activities/CaseTrackingUpdateRequest.js');
  reactHotLoader.register(_default, 'default', '/app/src/components/common-activities/CaseTrackingUpdateRequest.js');
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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